import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DataSharingService } from 'src/modules/shared/services/DataSharing.service';
import { AppConfigService } from 'src/modules/shared/services/app-config.service';
import { LoginService } from 'src/modules/login/services/login.service';

@Component({
  selector: 'app-why-should-iregister',
  templateUrl: './why-should-iregister.component.html',
  styleUrls: ['./why-should-iregister.component.scss']
})
export class WhyShouldIRegisterComponent implements OnInit {
cardsEN=[{
  iconClass:"icon-technical-support",
  description:"Full access to our services"
},
{
  iconClass:"icon-analytics",
  description:"Single click to your workspace"
},
{
  iconClass:"icon-clipboards",
  description:"Tracking all your tasks and notifications"
}
]
cardsAR=[{
  iconClass:"icon-technical-support",
  description:"الوصول لجميع الخدمات؟"
},
{
  iconClass:"icon-analytics",
  description:"الوصول الى مساحة العمل بسهولة"
},
{
  iconClass:"icon-clipboards",
  description:"تتبع المهام والإشعارات"
}
]
cards =[];
loggedIn :any;

  constructor(
    private loginService: LoginService,
    private dataSharingService:DataSharingService) {
    this.dataSharingService.isUserLoggedIn.subscribe(value => {
      this.loggedIn = value;
    });
  }

  ngOnInit() {
    // this.loggedIn= sessionStorage.getItem("loggedIn");
    localStorage.getItem('lang') == 'ar' ? localStorage.getItem('lang') + '-SA' : 'en';
    if( localStorage.getItem('lang') == 'ar' )
    {
    this.cards=this.cardsAR;
    }
    else
    {
      this.cards=this.cardsEN;
    }
  }

  Register(){
    this.loginService.RegisterToLogin();
  }

}
